// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:35:01+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1f9fbfb00e90d309115198100029eb74
//    Signature:      eyJpdiI6InVrVlBcL3NGb3ZXZng2UkhqU3lZbEZBPT0iLCJ2YWx1ZSI6IktxR1V1SzJhcHFibHY4NHYzYnFGeUxSY1I2UWF5QW9UWkJVWkZoXC9mWDhvXC9iR2tmU0dYQkROdkVSOTlqY3d1RGFKQWZGK0RDMnd3OG93T1NOQ2lod2JlQjRrb2JCcG9pOHJFUkpUeksybjFnRFJxd0hJRFExWXFiaFwvdlB0RXNqa0lRU1ZZaldpbmNLQkZkSjVLRFFqTmppdHpDMEVvRE5oXC9sbm81ak9xS1BDeUlHZXFcL2ltZnA5d0hvd3hETU5oYk5Sb2dQRjdrODJlTEJSazRHYWpia2czYU1kNnYrb3EwSzh2TFZLbkZiNmhDR0liUVpMYlQxNm9vbGtxXC9Hb1Bzem43VVBFRFkxSWpMWkhEdUUwZ1wvcUFBQ01uUUN2QUVFZ1kyclBtT2JsbXpBejdoTjM3SHVtVm1iWnBub3IxUlMrbTd3aVoweXFYcXp3OGpcLzY4WTkwNWp6ejEwbjR0cGg1RmpHTkJnbEVBbkFEYXZqN1ltK2gzUGcyM0xFR3lIeWRDS3EwYzZmbU9lY1V6TmNnS0RiZz09IiwibWFjIjoiNjdlOThlZDFjZmIzZDRlYjVjMmQ1OTQ0ZWI2N2JjZDhiNGU3ZjhhMDYzZmIzOGQwMjUwOWJlYmE4MDVmZDM2MyJ9
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
